import { styled } from '../theming';

/**
 * Accessibility utility component. Hides its contents visually, but still surfaces them to screen readers.
 *
 * [online documentation](https://doc.babbel.com/lessonnine/design-system.lib/index.html?path=/docs/components-utils-visuallyhidden--docs)
 *
 * @see https://www.w3.org/WAI/tutorials/forms/labels/
 */
export const VisuallyHidden = styled.span({
  position: 'absolute',
  margin: -1,
  padding: 0,
  height: 1,
  width: 1,
  border: 0,
  clip: 'rect(0 0 0 0)',
  overflow: 'hidden',

  // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
  whiteSpace: 'nowrap',
  wordWrap: 'normal',
});
